import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import './styles.scss'
import { updateInCart } from '../../../store/modules/cart/actions'
import {
  isFirstStep,
  isSecondStep,
  retrieveProducts
} from '../../../utils/helpers'

const ProductList = ({
  chosenProduct,
  setChosenProduct,
  products,
  setProducts,
  TypeComponent,
  type,
  setIsSelectionVisible,
  subscriptionInCart,
  actualFreebieProducts,
  secondStepGiftsAvailable
}) => {
  const { t } = useTranslation()
  const productsStore = useSelector(({ products }) => products)
  const cart = useSelector(({ cart }) => cart)
  const dispatch = useDispatch()

  const _gifts = retrieveProducts(cart, productsStore, document.querySelector('meta[name="gifts"]').content)
  const cartContainsBundle = cart?.items?.some(item => item.sku.includes('BUNDLE'))
  const welcomeKit = cartContainsBundle ? productsStore.length && productsStore.find(({ sku }) => _gifts?.includes(sku)) : ''

  useEffect(() => {
    setProducts(retrieveProducts(cart, productsStore, document.querySelector(`meta[name="${type}s"]`).content))
  }, [productsStore, cart])

  const fullProducts = products?.map(product => productsStore.find(p => p.sku === product)).filter(s => s)
  const secondFreeProductsThreshold = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? null

  /**
   * When user add a gift, we will check the cart amount and check how many gifts
   * he has already add.
   *
   * If cart total_price is greater than 54.90€ and lower than 79.90€ we will
   * add the selected gift. If he try to add another one, we will replace the
   * gift by the new selected one.
   *
   * If cart total_price is greater than 79.90€ we will allow customer to select
   * a second gift. Customer can not add a third gift.
   *
   * If a user select sample, we will check if he already selected one. If yes,
   * we will replace the selected sample
   * @param product
   * @return {*}
   */
  const addChosenProduct = (product, secondStepGiftsAvailable) => {
    const productQuantity = cart.items.find(item => item.sku === product.sku)?.quantity || 0

    if (type === 'sample') {
      const sampleToReplace = cart.items.find(({ sku }) => sku.startsWith('ECH.'))
      dispatch(updateInCart(
        product,
        productQuantity + 1,
        sampleToReplace ?? null,
        0
      ))

      return setChosenProduct(product)
    }

    const gifts = retrieveProducts(cart, productsStore, document.querySelector('meta[name="gifts"]').content)
    const secondGifts = retrieveProducts(cart, productsStore, document.querySelector('meta[name="gifts-second-step"]').content)

    if (isSecondStep(cart.total_price, secondStepGiftsAvailable)) {
      const findFirstStepGifts = cart?.items?.find(item => gifts.length && gifts.includes(item.sku))
      const findSecondStepGifts = cart?.items?.find(item => secondGifts.length && secondGifts.includes(item.sku))

      if (findSecondStepGifts && findFirstStepGifts) {
        dispatch(updateInCart(
          product,
          productQuantity + 1,
          findSecondStepGifts,
          findSecondStepGifts.quantity - 1
        ))
      } else if (findSecondStepGifts && !findFirstStepGifts) {
        dispatch(updateInCart(
          product,
          productQuantity + 1
        ))
      } else {
        dispatch(updateInCart(product, productQuantity + 1))
      }

      setChosenProduct(product)
    }

    if (isFirstStep(cart.total_price) || !secondFreeProductsThreshold || !secondStepGiftsAvailable) {
      const actualFreebieProductsSKUS = actualFreebieProducts.map(({ sku }) => sku)[0]
      const toRemove = cart.items.find(({ sku }) => sku === actualFreebieProductsSKUS)
      const cartContainsGifts = cart?.items?.some(item => item.product_type === 'freebie')

      if (!cartContainsGifts) {
        dispatch(updateInCart(product, productQuantity + 1))
      } else {
        dispatch(updateInCart(
          product,
          productQuantity + 1,
          toRemove,
          toRemove.quantity - 1
        ))
      }

      setChosenProduct(product)
    }
  }

  return (
    <>
      {fullProducts && fullProducts.length > 0 &&
        <div className='slide-cart-product-container'>
          {type === 'sample' && <div className='slide-cart-product-text'>{t(`slideCart:${type}`)}</div>}

          <div className='slide-cart-product'>
            {fullProducts.map((product, i) =>
              <TypeComponent
                product={product}
                gifts={products}
                chosenProduct={chosenProduct}
                addChosenProduct={addChosenProduct}
                setIsSelectionVisible={setIsSelectionVisible}
                key={i}
                subscriptionInCart={subscriptionInCart}
                cart={cart}
                addGift={() => dispatch(updateInCart(welcomeKit, 1))}
                removeGift={() => dispatch(updateInCart(welcomeKit, 0))}
                secondStepGiftsAvailable={secondStepGiftsAvailable}
              />
            )}
          </div>
        </div>}
    </>
  )
}

export default ProductList
